import React from "react"

import { COMMON_THEME } from "../../constants/theme"

interface RadialProgressBarProps {
  progress: number
  size?: number
  strokeWidth?: number
}

const RadialProgressBar = ({ progress, size = 100, strokeWidth = 10 }: RadialProgressBarProps) => {
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const offset = circumference - (progress / 100) * circumference

  return (
    <svg width={size} height={size} style={{ minWidth: size }}>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="lightgray"
        strokeWidth={strokeWidth}
        fill="transparent"
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={COMMON_THEME.SUCCESS}
        strokeWidth={strokeWidth}
        fill="transparent"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        style={{ transition: "stroke-dashoffset 0.3s" }}
      />
      <text
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize="14px"
        fill="black"
      >
        {`${progress.toFixed(2)}%`}
      </text>
    </svg>
  )
}

export default RadialProgressBar